import React from "react";
import { Link } from "react-router";

const SearchResults = (props) => {
  const handleResultItems = (item) => {
    if (item.key === "neighborhood" || item.key === "postalTown") {
      return (
        <div
          className="result-values"
          onClick={() => props.handleLocationChange(item)}
        >
          {item.value}
        </div>
      );
    } else if (item.listingLink) {
      return (
        <div className="result-values">
          <Link to={item.listingLink}>{item.value}</Link>
        </div>
      );
    }
    return <div className="result-values">{item.value}</div>;
  };

  const getGroupName = (key) => {
    switch (key) {
      case "neighborhood":
        return "Neighborhood";
      case "postalTown":
        return "City";
      case "listing":
        return "Listings";
      default:
        return "Listings";
    }
  };
  const getDataBlock = (key) => {
    return (
      <div className="result-list">
        <div className="result-block">
          <div className="key-header">{getGroupName(key)}</div>
          {props.data[key].map((item) => handleResultItems(item))}
          {key === "listing" && props.data[key].length > 4 ? (
            <div className="view-more" onClick={() => props.viewMoreListings()}>
              View more...
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  };
  return (
    <div className="search-result-container">
      {Object.keys(props.data).map((key) => getDataBlock(key))}
    </div>
  );
};

export default SearchResults;



// WEBPACK FOOTER //
// ./src/components/search/search-box/searchResults.jsx